/**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $goToTop      = $el.find('.go-to-top');
const $btnOpenModal = $el.find('[data-open-modal-docs]');
const $modalDocs    = $('[data-component="modals/modal-docs"]');

const $modalFaq        = $('[data-component="modals/modal-faq"]');
const $btnOpenModalFaq = $el.find('[data-open-modal-faq]');

$goToTop.on('click', function() {
    Navigation.helpers.scrollTo(0);
});

$btnOpenModal.on('click', function() {
    const $this = $(this);

    $modalDocs.trigger('open', [$this.data('open-modal-docs')]);
});

$btnOpenModalFaq.on('click', function() {
    $modalFaq.trigger('open');
});
